<template>
  <div class=" tool-box clearfix">
    <div class="left clearfix">
      <Board class="board" />
      <Backlog class="backlog" />
      <Navigation class="nav" />
    </div>
    <div class="right">
      <AddressBook />
    </div>
  </div>
</template>

<script>
import Board from '@/components/information/Board.vue';
import Backlog from '@/components/information/Backlog.vue';
import AddressBook from '@/components/AddressBook/index.vue';
import Navigation from '@/components/Navigation/index.vue';

export default {
  components: {
    Board, Backlog, AddressBook, Navigation,
  },
};
</script>

<style lang="scss" scoped>
.tool-box {
  position: relative;
  width: 100%;
  .left {
    float: left;
    width: 1080px;
    .backlog,
    .board,
    .nav {
      float: left;
      margin-right: 20px;
      width: 520px;
    }
    .nav {
      margin-top: 20px;
      width: 1060px;
    }
  }
  .right {
    position: absolute;
    right: 0;
    width: 340px;
    height: 100%;
  }
}
</style>
